import React from 'react';

import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import ThemeButtons from '../../components/theme/ThemeButtons';
import LocalizationDropdown from '../../components/localization-dropdown/LocalizationDropdown';

import scss from './ConsumerHeader.module.scss';

function ConsumerHeader({ AdditionalActions, children }) {
  return (
    <header className={scss.header}>
      <div className={scss.logo}>
        <Icon icon={ICONS.Logo} className={scss.factiveLogo} />
        <Icon icon={ICONS.Factive} className={scss.factiveLabel} />
      </div>

      {children}

      <div className={scss.actions}>
        {AdditionalActions ? AdditionalActions : null}

        <div className={scss.themeSwitch}>
          <ThemeButtons />
        </div>

        <LocalizationDropdown placement='bottom' />
      </div>
    </header>
  );
}

export default ConsumerHeader;
